import { Auth, TAuthParams } from "../../hooks/auth";
import { AxiosHttpClient } from "../httpClient/axios-http-client.service";

export class AuthService extends AxiosHttpClient {
  public static async signIn (params: TAuthParams): Promise<Auth> {
    const { data } = await this.axiosHttpClient.post("/sessions", params);
    return data;
  }
}